import { useEffect } from "react";

const sections = [
  {
    id: "01",
    title: "Definitions",
    items: [
      '"IBH", "we", "our", or "us" refers to India Business Helpline.',
      '"User", "client", or "you" refers to any person accessing or using the website.',
      '"Services" refers to consulting, advisory, compliance, registration, taxation, business support, recruitment support, technology support, and related services.',
    ],
  },
  {
    id: "02",
    title: "Acceptance of Terms",
    content: [
      "By accessing this website, users acknowledge that they have read, understood, and agreed to these Terms & Conditions. If you do not agree with any part of these terms, please discontinue use of the website.",
    ],
  },
  {
    id: "03",
    title: "Nature of Services",
    content: [
      "IBH provides professional guidance, consultancy, facilitation, investments (via proper channel) and support services.",
      "Unless expressly stated:",
    ],
    items: [
      "IBH does not guarantee government approvals or registrations.",
      "Processing timelines may vary depending on authorities or third parties.",
      "Information provided on the website is for general informational purposes only.",
    ],
    footer:
      "Professional advice should be obtained before taking financial, legal, taxation, or business decisions.",
  },
  {
    id: "04",
    title: "User Responsibilities",
    content: ["Users agree:"],
    items: [
      "To provide accurate and truthful information",
      "Not to misuse the website",
      "Not to upload malicious content or attempt unauthorized access",
      "Not to engage in unlawful or fraudulent activities",
      "To maintain confidentiality of any login credentials",
    ],
    footer: "Users are solely responsible for the information submitted through the website.",
  },
  {
    id: "05",
    title: "Intellectual Property Rights",
    content: ["All website content including logos, branding, text, graphics, documents, layouts, designs, and software elements are the intellectual property of IBH unless otherwise stated."],
    footer:
      "Unauthorized copying, reproduction, distribution, or commercial use is prohibited. Unauthorized usage may attract legal consequences.",
  },
  {
    id: "06",
    title: "Payments & Fees",
    items: [
      "Fees for services shall be communicated separately.",
      "Certain government charges, taxes, professional fees, or third-party expenses may apply additionally.",
      "Payments once made may be non-refundable unless specifically agreed otherwise in writing.",
      "GST and applicable taxes shall be charged as per Indian law.",
      "For investment facilitation, fundraising, investor connections, venture capital support, private equity support, debt funding, strategic partnerships, mergers & acquisitions, or related financial advisory engagements, IBH may charge a success fee, transaction fee, commission, or performance-linked professional fee upon successful completion or closure of the transaction.",
      "Applicable success fees, commissions, or commercial terms shall be separately communicated through proposals, engagement letters, agreements, mandates, MoUs, invoices, or written communication.",
      "By engaging IBH for investment or funding-related services, users acknowledge and agree that such success-based fees may apply.",
    ],
  },
  {
    id: "07",
    title: "Limitation of Liability",
    content: ["IBH shall not be liable for:"],
    items: [
      "Indirect or consequential losses",
      "Business interruption",
      "Delay caused by government departments or third parties",
      "Loss arising from incorrect information submitted by users",
      "Technical failures, server downtime, or cyber incidents",
    ],
    footer:
      "Maximum liability, if any, shall be limited to the professional fee paid for the concerned service.",
  },
  {
    id: "08",
    title: "No Guarantee of Results",
    content: ["IBH provides professional assistance and guidance; however:"],
    items: [
      "Regulatory approvals are subject to authority discretion",
      "Financial or business outcomes cannot be guaranteed",
      "Market conditions and external factors may affect results",
    ],
  },
  {
    id: "09",
    title: "Third-Party Services",
    content: [
      "IBH may coordinate with external professionals, consultants, vendors, or technology providers.",
    ],
  },
  {
    id: "10",
    title: "Confidentiality",
    content: [
      "IBH shall make reasonable efforts to maintain confidentiality of client information shared for service purposes.",
      "However, disclosure may occur:",
    ],
    items: [
      "Where legally required",
      "For service execution purposes",
      "With client authorization",
    ],
  },
  {
    id: "11",
    title: "Website Availability",
    content: [
      "We do not guarantee uninterrupted access to the website.",
      "IBH reserves the right to:",
    ],
    items: [
      "Modify website content",
      "Suspend services",
      "Update features",
      "Restrict access",
    ],
    footer: "These actions may be taken without prior notice.",
  },
  {
    id: "12",
    title: "Indemnification",
    content: [
      "Users agree to indemnify and hold harmless IBH, its founders, employees, consultants, and affiliates against any claims, damages, liabilities, or expenses arising from:",
    ],
    items: [
      "Violation of these Terms",
      "Misuse of the website",
      "Submission of false information",
      "Unlawful activities",
    ],
  },
  {
    id: "13",
    title: "Governing Law & Jurisdiction",
    content: [
      "These Terms & Conditions shall be governed by the laws of India. Any disputes shall be subject to the jurisdiction of courts located in Kolkata, West Bengal.",
    ],
  },
  {
    id: "14",
    title: "Changes to Terms",
    content: [
      "IBH reserves the right to revise these Terms & Conditions at any time. Continued use of the website after updates constitutes acceptance of the revised terms.",
    ],
  },
  {
    id: "15",
    title: "Sponsorship Payment & Bank Details",
    content: [
      "All sponsorship deliverables, branding, promotional activities, and associated benefits are subject to the successful receipt and credit of the agreed sponsorship amount into IBH's designated bank account. IBH shall not be obligated to initiate or fulfill any sponsorship deliverables until the payment has been received in full.",
      "Any delay, partial payment, or failure to complete payment may result in the postponement or suspension of the corresponding deliverables. IBH shall not be held liable for any delay or non-delivery of sponsorship benefits arising from such circumstances.",
      "Bank Details:",
    ],
    items: [
      "Account Name: India Business Helpline",
      "Bank Name: ICICI Bank",
      "Account Number: 268805000956",
      "IFSC Code: ICIC0002688",
    ],
  },
];

export default function TermsAndConditions() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  return (
    <div style={{ fontFamily: "'DM Sans', 'Helvetica Neue', sans-serif", background: "#f8f8fc", minHeight: "100vh" }}>
      <style>{`
        * { box-sizing: border-box; }

        .header-gradient {
          background: linear-gradient(135deg, #1a1a2e 0%, #2d1b5e 60%, #1a2e4a 100%);
          padding: 48px 40px 40px;
          position: relative;
          overflow: hidden;
        }
        .header-gradient::before {
          content: '';
          position: absolute;
          top: -60px; right: -60px;
          width: 300px; height: 300px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(249,115,22,0.18) 0%, transparent 70%);
        }
        .header-gradient::after {
          content: '';
          position: absolute;
          bottom: -40px; left: 20%;
          width: 200px; height: 200px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(139,92,246,0.2) 0%, transparent 70%);
        }

        .back-btn {
          display: inline-flex;
          align-items: center;
          gap: 7px;
          color: rgba(255,255,255,0.6);
          font-size: 13px;
          font-weight: 500;
          cursor: pointer;
          border: none;
          background: rgba(255,255,255,0.08);
          font-family: 'Inter', sans-serif;
          margin-bottom: 24px;
          transition: color 0.15s;
          padding: 6px 14px;
          border-radius: 20px;
        }
        .back-btn:hover { color: rgba(255,255,255,0.9); }

        .section-card {
          background: #fff;
          border-radius: 16px;
          border: 1px solid #ebebf5;
          padding: 28px 32px;
          transition: box-shadow 0.2s ease;
        }
        .section-card:hover {
          box-shadow: 0 8px 32px rgba(0,0,0,0.07);
        }

        .section-id {
          font-family: 'Inter', sans-serif;
          font-size: 11px;
          font-weight: 600;
          letter-spacing: 0.08em;
          color: #F97316;
          margin-bottom: 8px;
        }

        .section-title {
          font-family: 'Poppins', sans-serif;
          font-size: 17px;
          font-weight: 700;
          color: #1a1a2e;
          margin-bottom: 14px;
        }

        .section-text {
          font-family: 'Inter', sans-serif;
          font-size: 14px;
          color: #4a4a6a;
          line-height: 1.75;
          margin-bottom: 8px;
        }

        .section-item {
          display: flex;
          align-items: flex-start;
          gap: 10px;
          font-family: 'Inter', sans-serif;
          font-size: 14px;
          color: #4a4a6a;
          line-height: 1.7;
          margin-bottom: 8px;
        }

        .section-item-dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: #F97316;
          margin-top: 8px;
          flex-shrink: 0;
        }

        .footer-note {
          font-family: 'Inter', sans-serif;
          font-size: 12px;
          color: #9090b0;
          font-style: italic;
          margin-top: 12px;
          padding-top: 12px;
          border-top: 1px solid #f0f0fa;
        }

        @media (max-width: 768px) {
          .header-gradient { padding: 32px 20px 28px; }
          .content-area { padding: 20px !important; }
          .section-card { padding: 20px; }
        }
      `}</style>

      {/* ── HEADER ── */}
      <div className="header-gradient">
        <button className="back-btn" onClick={() => window.history.back()}>
          &lt; Back
        </button>
        <div style={{ position: "relative", zIndex: 1 }}>
          <h1 style={{
            fontFamily: "'Poppins', sans-serif",
            fontSize: "clamp(28px, 5vw, 42px)",
            fontWeight: 700,
            color: "#fff",
            lineHeight: 1.15,
            marginBottom: 10,
          }}>
            Terms &amp;{" "}
            <span style={{
              background: "linear-gradient(90deg, #F97316, #EC4899, #8B5CF6)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              fontFamily: "'Poppins', sans-serif",
              fontWeight: 700,
              fontSize: "inherit",
            }}>
              Conditions
            </span>
          </h1>
          <p style={{
            color: "rgba(255,255,255,0.6)",
            fontSize: 15,
            maxWidth: 480,
            lineHeight: 1.6,
            fontFamily: "'Inter', sans-serif",
          }}>
            These terms govern your access to and use of India Business Helpline's website and services.
          </p>
        </div>
      </div>

      {/* ── CONTENT ── */}
      <div
        className="content-area"
        style={{ padding: "32px 40px 60px", display: "flex", flexDirection: "column", gap: 16 }}
      >
        {sections.map((section) => (
          <div key={section.id} className="section-card">
            <div className="section-id">SECTION {section.id}</div>
            <div className="section-title">{section.title}</div>

            {/* Intro paragraphs */}
            {section.content?.map((para, i) => (
              <p key={i} className="section-text">
                {para.startsWith("__bold__")
                  ? <strong>{para.replace("__bold__", "")}</strong>
                  : para.startsWith("__italic__")
                  ? <em>{para.replace("__italic__", "")}</em>
                  : para}
              </p>
            ))}

            {/* Bullet items */}
            {section.items?.map((item, i) => (
              <div key={i} className="section-item">
                <span className="section-item-dot" />
                <span>{item}</span>
              </div>
            ))}

            {/* Footer note */}
            {section.footer && (
              <div className="footer-note">{section.footer}</div>
            )}
          </div>
        ))}

        {/* Bottom strip */}
        <div style={{
          marginTop: 8,
          paddingTop: 24,
          borderTop: "1px solid #ebebf5",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 8,
          fontFamily: "'Inter', sans-serif",
          fontSize: 12,
          color: "#9090b0",
        }}>
          <span>© {new Date().getFullYear()} India Business Helpline. All rights reserved.</span>
          <a href="mailto:indianbusinesshelpline@gmail.com" style={{ color: "#F97316", textDecoration: "none" }}>
            connect@myibh.in
          </a>
        </div>
      </div>
    </div>
  );
}